// extracted by mini-css-extract-plugin
export var addToCartButton = "_nd-b";
export var arrowButtonContainer = "_nd-9";
export var arrowButtonIcon = "_nd-a";
export var carouselArrowButton = "_nd-6";
export var carouselElementContainer = "_nd-1";
export var left = "_nd-7";
export var productDisplayCarouselContainer = "_nd-0";
export var productTileContainer = "_nd-2";
export var productTileImage = "_nd-4";
export var productTileImageContainer = "_nd-3";
export var productTileTitle = "_nd-5";
export var right = "_nd-8";
export var sliderOverflow = "_nd-c";